/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {agentWalletRetrievePayment} from '../api'

export const useMutationAgentWalletRetrievePayment = createReactQueryMutationHook('agentWalletRetrievePayment', agentWalletRetrievePayment)
